<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" :tip="loadTip">
      <a-row :gutter="{ xs: 8, sm: 16, md: 16}">
        <a-col :xs="0" :sm="1" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
        <a-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18" :xxl="18" style="margin-top:30px">
          <a-form :form="form" layout="horizontal">
            <a-row>
              <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="display:flex; justify-content: center;display:grid;">
                <a-upload class="gpws-pic" list-type="picture-card" :show-upload-list="false" @preview="(file)=>handlePicPreview(file, 'LIC')" :before-upload="beforePicUpload" :custom-request="(file)=>handleImgUpload(file, 'LIC')">
                  <img style="width: 125px; height: 125px;" v-if="((undefined != pics.lic && null != pics.lic && '' != pics.lic) || (undefined != record.lic && null != record.lic && '' != record.lic))" :src="record.lic||pics.lic" />
                  <div v-else>
                    <a-icon :type="'plus'" />
                    <div class="ant-upload-text">
                      营业执照
                    </div>
                  </div>
                </a-upload>
                <span class="pic-desc">请优先上传营业执照<label style="color: red">*</label></span>
              </a-col>
            </a-row>
            <a-row>
              <a-col span="8">
                <a-form-item :colon="false" label="机构名称" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                  <a-input v-decorator="['name', { rules: [{ required: true, message: '机构名称必须填写!' }] , initialValue: record.name}]"/>
                </a-form-item>
              </a-col>
              <a-col span="8">
                <a-form-item :colon="false" label="统一社会信用代码" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  <a-input v-decorator="['organCode', { rules: [{ required: true, message: '组织机构代码必须填写!' }], initialValue: record.organCode }]"/>
                </a-form-item>
              </a-col>
              <a-col span="8">
                <a-form-item :colon="false" label="营业执照有效期" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  <a-date-picker :disabled="forever" style="width: 120px" ref="organValidDate" v-decorator="['organValidDate', { rules: [{ required: !forever, message: '营业执照有效期必须填写!' }], initialValue: (((forever||false)===true)?'':record.organValidDate) }]"
                                 valueFormat="YYYY-MM-DD"
                  />
                  <a-checkbox :checked="forever" style="margin-left: 10px" @change="foreverChange" >长期</a-checkbox>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col span="16">
                <a-form-item :colon="false" label="所属地区" style="white-space: nowrap;" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                  <a-select @change="loadCitys" style="width: 150px;" v-decorator="['district', { rules: [{ required: true, message: '所属地区必须选择!' }], initialValue: record.province }]">
                    <a-select-option  v-for="(item, index) in provinces" :key="'p' + index" :value="item.id">{{item.name}}</a-select-option>
                  </a-select>省
                  <a-select @change="loadCountys" v-model="record.city" style="width: 150px;">
                    <a-select-option  v-for="(item, index) in citys" :key="'c' + index" :value="item.id">{{item.name}}</a-select-option>
                  </a-select>市
                  <a-select  v-model="selectCounty" style="width: 150px;">
                    <a-select-option  v-for="(item, index) in countys" :key="'x' + index" :value="item.id">{{item.name}}</a-select-option>
                  </a-select>县
                </a-form-item>
              </a-col>
              <a-col span="8">
                <a-form-item :colon="false" label="机构详细地址" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  <a-input @change="addressChange" v-decorator="['address', { rules: [{ required: true, message: '机构详细地址必须填写!' }], initialValue: (null!=record.address && ''!=record.address && undefined!=record.address)?record.address.address:'' }]"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col span="24">
                <a-form-item :colon="false" label="坐标位置" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
                  <a-auto-complete placeholder="请输入关键字检索地址" v-model="location.keyword" option-label-prop="label" @search="value => autoCompleteSearch(value)" @select="value => autoCompleteSelect(value)" style="width: 180px;" :dropdown-match-select-width="false" :dropdown-style="{'width': '400px'}">
                    <template slot="dataSource">
                      <template v-if="((location.datas||[]).length > 0)">
                        <a-select-option v-for="(item, index) in location.datas" :key="'loc-'+(index + 1)+'-'+item.id" :label="item.title" :value="item.id">
                          <a-row>
                            <a-col span="8">
                              {{ item.title }}
                            </a-col>
                            <a-col span="12">
                              {{ item.address }}
                            </a-col>
                          </a-row>
                        </a-select-option>
                      </template>
                    </template>
                  </a-auto-complete>

                  <a-input style="width: 160px;margin-left: 10px" :disabled="true" v-decorator="['lat', { rules: [{ required: false, message: '机构坐标必须选择!' }], initialValue: (null!=record.address && null!=record.address.location)?record.address.location.y:'' }]"/>
                  <a-input style="width: 160px; margin-left: 10px" :disabled="true" v-decorator="['lng', { rules: [{ required: false, message: '机构坐标必须选择!' }], initialValue: (null!=record.address && null!=record.address.location)?record.address.location.x:'' }]"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col span="1">
              </a-col>
              <a-col span="23" class="custom-line">
              </a-col>
            </a-row>
            <a-row style="margin-top:15px">
              <a-col :xxl="4" :xl="4" :lg="4" :md="4" :sm="4" :xs="4"></a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="8" :sm="24" :xs="24" style="justify-content: center;display:grid;">
                <a-upload class="gpws-pic" list-type="picture-card" :show-upload-list="false" @preview="(file)=>handlePicPreview(file, 'LIF')" :before-upload="beforePicUpload" :custom-request="(file)=>handleImgUpload(file, 'LIF')">
                  <img style="width: 125px; height: 125px;" v-if="((undefined != pics.lif && null != pics.lif && '' != pics.lif) || (undefined != record.lif && null != record.lif && '' != record.lif))" :src="record.lif||pics.lif" />
                  <div v-else>
                    <a-icon :type="'plus'" />
                    <div class="ant-upload-text">
                      法人身份证<br>(人像面)
                    </div>
                  </div>
                </a-upload>
                <span class="pic-desc">点击上传身份证人像面<label style="color: red">*</label></span>
              </a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="8" :sm="24" :xs="24" style="justify-content: center;display:grid;">
                <a-upload class="gpws-pic" list-type="picture-card" :show-upload-list="false" @preview="(file)=>handlePicPreview(file, 'LIB')" :before-upload="beforePicUpload" :custom-request="(file)=>handleImgUpload(file, 'LIB')">
                  <img style="width: 125px; height: 125px;" v-if="((undefined != pics.lib && null != pics.lib && '' != pics.lib) || (undefined != record.lib && null != record.lib && '' != record.lib))" :src="record.lib||pics.lib" />
                  <div v-else>
                    <a-icon :type="'plus'" />
                    <div class="ant-upload-text">
                      法人身份证<br>(国徽面)
                    </div>
                  </div>
                </a-upload>
                <span class="pic-desc">点击上传身份证国徽面<label style="color: red">*</label></span>
              </a-col>
              <a-col :xxl="4" :xl="4" :lg="4" :md="4" :sm="4" :xs="4"></a-col>
            </a-row>

            <a-row>
              <a-row>
                <a-col span="4">
                </a-col>
                <a-col span="8">
                  <a-form-item :colon="false" label="法人姓名" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-input ref="leaderName" v-decorator="['leaderName', { rules: [{ required: true, message: '法人姓名必须填写!' }], initialValue: (undefined != record.leaderName && null != record.leaderName)?record.leaderName:''}]"/>
                  </a-form-item>
                </a-col>
                <a-col span="8">
                  <a-form-item :colon="false" label="身份证号" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-input ref="leaderIdcard" v-decorator="['leaderIdcard', { rules: [{ required: true, message: '法人身份证号必须填写!' }],initialValue: (undefined != record.leaderIdcard && null != record.leaderIdcard)?record.leaderIdcard:'' }]"/>
                  </a-form-item>
                </a-col>
                <a-col span="4">
                </a-col>
              </a-row>
              <a-row>
                <a-col span="4">
                </a-col>
                <a-col span="8">
                  <a-form-item :colon="false" label="证件有效开始日期" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-date-picker ref="leaderStartDate" v-decorator="['leaderStartDate', { rules: [{ required: true, message: '证件有效开始日期必须填写!' }], initialValue: (undefined != record.leaderStartDate && null != record.leaderStartDate)?record.leaderStartDate:'' }]"
                                   valueFormat="YYYY-MM-DD"
                    />
                  </a-form-item>
                </a-col>
                <a-col span="8">
                  <a-form-item label="证件有效结束日期" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-date-picker ref="leaderEndDate" v-decorator="['leaderEndDate', { rules: [{ required: true, message: '证件有效结束日期必须填写!' }], initialValue: (undefined != record.leaderEndDate && null != record.leaderEndDate)?record.leaderEndDate:'' }]"
                                   valueFormat="YYYY-MM-DD"
                    />
                  </a-form-item>
                </a-col>

                <a-col span="4">
                </a-col>
              </a-row>
              <a-row>
                <a-col span="4">
                </a-col>
                <a-col span="8">
                  <a-form-item label="手机号码" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-input v-decorator="['leaderPhone', { rules: [{ required: false, message: '法人手机号码必须填写!' }] ,initialValue: (undefined != record.leaderPhone && null != record.leaderPhone)?record.leaderPhone:''}]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-row>

            <a-row>
              <a-col span="1">
              </a-col>
              <a-col span="23" class="custom-line">
              </a-col>
            </a-row>
            <a-row style="margin-top:15px">
              <a-col :xxl="4" :xl="4" :lg="4" :md="4" :sm="4" :xs="4"></a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="8" :sm="24" :xs="24" style="justify-content: center;display:grid;">
                <a-upload class="gpws-pic" list-type="picture-card" :show-upload-list="false" @preview="(file)=>handlePicPreview(file, 'PC')" :before-upload="beforePicUpload" :custom-request="(file)=>handleImgUpload(file, 'PC')">
                  <img style="width: 125px; height: 125px;" v-if="((undefined != pics.pc && null != pics.pc && '' != pics.pc) || (undefined != record.pc && null != record.pc && '' != record.pc))" :src="record.pc||pics.pc" />
                  <div v-else>
                    <a-icon :type="'plus'" />
                    <div class="ant-upload-text">
                      医疗机构执业许可证
                    </div>
                  </div>
                </a-upload>
                <span class="pic-desc">医疗机构执业许可证<label v-if="record.type=='HOSPITAL' || record.type == 'CLINIC'" style="color: red">*</label></span>
              </a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="8" :sm="24" :xs="24" style="justify-content: center;display:grid;">
                <a-upload class="gpws-pic" list-type="picture-card" :show-upload-list="false" @preview="(file)=>handlePicPreview(file, 'GSP')" :before-upload="beforePicUpload" :custom-request="(file)=>handleImgUpload(file, 'GSP')">
                  <img style="width: 125px; height: 125px;" v-if="((undefined != pics.gsp && null != pics.gsp && '' != pics.gsp) || (undefined != record.gsp && null != record.gsp && '' != record.gsp))" :src="record.gsp||pics.gsp" />
                  <div v-else>
                    <a-icon :type="'plus'" />
                    <div class="ant-upload-text">
                      药品经营许可证
                    </div>
                  </div>
                </a-upload>
                <span class="pic-desc">药品经营许可证<label v-if="record.type=='HOSPITAL' || record.type == 'PHARMACY' || record.type == 'DELIVERY'" style="color: red">*</label></span>
              </a-col>
              <a-col :xxl="4" :xl="4" :lg="4" :md="4" :sm="4" :xs="4"></a-col>
            </a-row>

            <a-row>
              <a-col span="6"></a-col>
              <a-col span="10">
                <a-form-item :label="(record.type=='HOSPITAL' || record.type == 'CLINIC')?'医疗机构执业许可证号':'药品经营许可证号'" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  <a-input v-decorator="['practiceNo', { rules: [{ required: true, message: ((record.type=='HOSPITAL' || record.type == 'CLINIC')?'医疗机构执业许可证号':'药品经营许可证号')+'必须填写!' }] ,initialValue: record.practiceNo||''}]"/>
                </a-form-item>
              </a-col>
              <a-col span="8"></a-col>
            </a-row>
            <a-row>
              <a-col span="1">
              </a-col>
              <a-col span="23" class="custom-line">
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="display:flex; justify-content: center;display:grid;">
                <a-upload class="gpws-pic" list-type="picture-card" :show-upload-list="false" @preview="(file)=>handlePicPreview(file)" :before-upload="beforePicUpload" :custom-request="(file)=>handleOrganImgUpload(file)">
                  <img style="width: 94px; height: 72px;" v-if="(undefined != record.pic && null != record.pic && '' != record.pic.url!='')" :src="record.pic.url" />
                  <div v-else>
                    <a-icon :type="'plus'" />
                    <div class="ant-upload-text">
                      封面图片<br />
                      建议尺寸94*72
                    </div>
                  </div>
                </a-upload>
                <span class="pic-desc">医疗机构封面<label style="color: red">*</label></span>
              </a-col>
            </a-row>
            <a-row>
              <a-col span="4">
              </a-col>
              <a-col span="16">
                <a-form-item label="机构类型" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  <a-select v-decorator="['category', {rules: [{ required: (record.type != 'DELIVERY'), message: '医疗机构类型必须选择!' }], initialValue: (undefined != record.category && null !=record.category && '' != record.category)?record.category:''}]">
                    <a-select-option v-for="(item, index) in init.categories" :key="'t'+index" :value="item.name">{{item.value}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col span="4">
              </a-col>
            </a-row>
            <a-row>
              <a-col span="4">
              </a-col>
              <a-col span="8">
                <a-form-item label="是否为互联网医院" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  <a-radio-group v-decorator="['carp', {rules: [{ required: true, message: '互联网医院必须选择!' }], initialValue: (record.carp?'1':'0')}]">
                    <a-radio value="1">是</a-radio>
                    <a-radio value="0">否</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col span="8">
                <a-form-item label="是否为医保定点单位" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  <a-radio-group v-decorator="['hcUnit', {rules: [{ required: true, message: '医保定点单位必须选择!' }], initialValue: (record.hcUnit?'1':'0')}]">
                    <a-radio value="1">是</a-radio>
                    <a-radio value="0">否</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col span="4">
              </a-col>
            </a-row>
          </a-form>
          <div class="button-container" style="float:right;margin-right: 48px;">
            <div>
              <a-button type="primary" style="margin-left: 24px;" @click="saveOrgan">保存</a-button>
              <a-button icon="double-left" style="margin-left: 24px;" @click="goBack">返回</a-button>

            </div>
          </div>
        </a-col>
        <a-col :xs="0" :sm="5" :md="5" :lg="5" :xl="5" :xxl="5">&nbsp;</a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue';
import Vue from 'vue'
import hevueImgPreview from 'hevue-img-preview';
Vue.use(hevueImgPreview);
export default {
  name: "OrganEdit",
  components: {
    Map
  },
  data() {
    return {
      loading:false,
      loadTip:'',
      current: {},
      form: this.$form.createForm(this),
      provinces:[],
      citys:[],
      countys:[],
      selectCounty:'',    //选中的区县
      location:{
        keyword:'',
        datas:[]
      },
      init:{
        categories:[]
      },
      forever: false,     //营业执照是否长期有效
      emptyImage:Empty.PRESENTED_IMAGE_SIMPLE,
      record:{},
      pics: {lif:'', lib:'', lic:'', pc:'', gsp:''}
    }
  },
  mounted() {
    const self = this;
    this.current = JSON.parse(localStorage.getItem("curruser"));

    this.provinces.push({id: '', name: '--请选择--'});
    this.getProvinces({params: {parentCode: '', level: 'PROVINCE'}}, function (res) {
      res.forEach(function (item) {
        self.provinces.push({id: item.id, name: item.name});
      });
    });
    this.$axios.get('/api/clinic/'+this.current.organId+'/mine').then(function (res) {
      if (res.msg.flag == 0) {
        if(null != res.biz){
          self.record = res.biz;
          if(self.record.organValidDate == null || self.record.organValidDate == undefined || self.record.organValidDate == ''){
            self.forever = true;
          }else{
            self.forever = false;
          }
          self.getHospitalTypes(res.biz.type, function (res) {
            self.init.categories = res;
          });

          if(undefined != res.biz.address && null != res.biz.address && undefined != res.biz.address.district && null != res.biz.address.district){
            self.loadDistrict(res.biz.address.district);
          }
          if(undefined != res.biz.address && null != res.biz.address && null==res.biz.address.location){
            let keyword = '';
            if(res.biz.address.district!=null && null!=res.biz.address.district.fullName){
              keyword = res.biz.address.district.fullName;
            }
            keyword = keyword + res.biz.address.address;
            self.location.keyword = keyword;
            self.autoCompleteSearch(keyword);
          }
          if(undefined != res.biz.certificates && null != res.biz.certificates && res.biz.certificates.length > 0){
            res.biz.certificates.forEach(function (e) {
              if(e.type=='LIF'){//身份证正面
                self.record.lif = e.path.url;
                self.pics.lif = e.path.path;
              }
              if(e.type=='LIB'){//身份证反面
                self.record.lib = e.path.url;
                self.pics.lib = e.path.path;
              }
              if(e.type=='LIC'){ //营业执照
                self.record.lic = e.path.url;
                self.pics.lic = e.path.path;
              }
              if(e.type=='PC'){//执业许可证
                self.record.pc = e.path.url;
                self.pics.pc = e.path.path;
              }
              if(e.type=='GSP'){//药品经营许可证
                self.record.gsp = e.path.url;
                self.pics.gsp = e.path.path;
              }
            });
          }
        }
      }
    }, function (res) {
    });
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "医院管理",
      path: ""
    },{
      text: "我的诊所",
      path: ""
    },{
      text: "资料修改",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  methods:{
    saveOrgan:function (){
      const self = this;
      if(undefined == this.pics.lic || null == this.pics.lic || '' == this.pics.lic){
        this.$message.error({content: '营业执照照片必须上传.', duration: 2});
        return;
      }
      if(undefined == this.pics.lif || null == this.pics.lif || '' == this.pics.lif){
        this.$message.error({content: '法人身份(人像面)必须上传.', duration: 2});
        return;
      }
      if(undefined == this.pics.lib || null == this.pics.lib || '' == this.pics.lib){
        this.$message.error({content: '法人身份(国徽面)必须上传.', duration: 2});
        return;
      }
      if(this.record.type == 'HOSPITAL' || this.record.type == 'CLINIC'){
        if(undefined == this.pics.pc || null == this.pics.pc || '' == this.pics.pc){
          this.$message.error({content: '医疗机构执业许可证必须上传.', duration: 2});
          return;
        }
      }
      if(this.record.type == 'HOSPITAL' || this.record.type == 'PHARMACY' || this.record.type == 'DELIVERY'){
        if(undefined == this.pics.gsp || null == this.pics.gsp || '' == this.pics.gsp){
          this.$message.error({content: '药品经营许可证必须上传.', duration: 2});
          return;
        }
      }

      this.form.validateFields((err, values) => {
        if(!err){
          let districtId='';
          if(undefined != self.selectCounty && null != self.selectCounty && '' != self.selectCounty){
            districtId = self.selectCounty;
          }else if(undefined != self.record.city && null != self.record.city && '' != self.record.city){
            districtId = self.record.city;
          }else{
            districtId = values.district;
          }
          let certificates=[];

          if(undefined != self.pics.lif && null != self.pics.lif && '' != self.pics.lif){
              certificates.push({type:'LIF', path:self.pics.lif});
          }
          if(undefined != self.pics.gsp && null != self.pics.gsp && '' != self.pics.gsp){
            certificates.push({type:'GSP', path:self.pics.gsp});
          }
          if(undefined != self.pics.lib && null != self.pics.lib && '' != self.pics.lib){
            certificates.push({type:'LIB', path:self.pics.lib});
          }
          if(undefined != self.pics.lic && null != self.pics.lic && '' != self.pics.lic){
            certificates.push({type:'LIC', path:self.pics.lic});
          }
          if(undefined != self.pics.pc && null != self.pics.pc && '' != self.pics.pc){
            certificates.push({type:'PC', path:self.pics.pc});
          }

          let _linkman = self.record.linkman||{name:'', phone:''};

          let organValidDate = values.organValidDate;
          if(self.forever){
            organValidDate = '';
          }

          let params = {id:self.record.id, name:values.name, organCode:values.organCode, districtId:districtId, level:self.record.level,
            address: values.address, category:((undefined == values.category || null == values.category || '' == values.category)?null:values.category),
            carp:(values.carp =='1'), hcUnit:(values.hcUnit == '1'), leaderName:values.leaderName, leaderIdcard:values.leaderIdcard,
            leaderPhone: values.leaderPhone, linkman:_linkman.name, linkPhone:_linkman.phone, certificates: certificates,
            type:values.type, leaderStartDate:values.leaderStartDate, leaderEndDate:values.leaderEndDate, organValidDate:organValidDate, practiceNo:values.practiceNo,
            pic:(null!=self.record.pic ? self.record.pic.path:'')};

          if(values.lat!=null && values.lat!='' && values.lng!=null && values.lng!=''){
            params.location = {latitude:values.lat, longitude:values.lng}
          }

          self.loadTip='正在保存...';
          self.loading = true;
          self.$axios.post('/api/clinic/hospital/modify', params).then(function(res){
            self.loading = false;
            if(res.msg.flag == 0){
              self.$message.success({content: '机构档案修改成功.', duration: 2});
              self.goBack();
            }else{
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(res){
            self.loading = false;
          });
        }
      });
    },

    addressChange:function(e){
      this.location.keyword = e.target.value;
      this.autoCompleteSearch(e.target.value)
    },

    /**
     * 根据关键字查询坐标信息
     */
    autoCompleteSearch:function(value){
      const self = this;
      console.info('value='+value)
      this.location.datas = [];
      if(undefined != value && null != value && '' != value && value.trim().length > 0){
        console.info()
        let region = '';
        this.$axios.get('/api/dmz/locations?region='+region+'&address='+value, {}).then(function (res) {
          if (res.msg.flag == 0) {
            self.location.datas = [];
            if(null != res.biz && !res.biz.empty){
              res.biz.forEach(function(e){
                self.location.datas.push(e);
              });
              self.form.setFieldsValue({
                'lat':self.location.datas[0].location.lat,
                'lng':self.location.datas[0].location.lng
              })
            }
          }
        }, function (res) {
        });
      }
    },

    autoCompleteSelect:function(value){
      let self = this;
      for(let item of this.location.datas){
        if(item.id == value){
          console.info(item);
          console.info(item.location.lat+' '+item.location.lng)
          setTimeout(function () {
            self.form.setFieldsValue({
              'lat':item.location.lat,
              'lng':item.location.lng
            })
          },10)

        }
      }
    },

    loadDistrict:function(district){
      if(undefined != district && null != district){
        if(district.level == 'PROVINCE'){
          this.record.province = district.oid;
          this.loadCitys(this.record.province);
        }else{
          if(undefined != district.ancestors && null != district.ancestors && district.ancestors.length > 0){
            this.record.province = district.ancestors[0];
            this.loadCitys(this.record.province);
            if(district.level == 'CITY'){
              this.record.city = district.oid;
              this.loadCountys(this.record.city);
            }else{
              if(district.ancestors.length > 1){
                this.record.city = district.ancestors[1];
                this.loadCountys(this.record.city);
                this.selectCounty = district.oid
              }
            }
          }
        }
      }
    },
    loadCitys: function(value){
      const self = this;
      this.record.city ='';
      this.selectCounty = '';
      this.currentValue = value;
      this.citys =[];
      this.citys.push({id: '', name: '--请选择--'});
      if(null != value && '' != value){
        this.$axios.get('/api/dmz/district/childrens', {params: {parentCode: value, level: 'CITY'}}).then(function (res) {
          if (res.msg.flag == 0) {
            if(null != res.biz && !res.biz.empty){
              res.biz.forEach(function (item, index) {
                self.citys.push({id: item.id, name: item.name});
              });
            }
          }
        }, function (res) {
        });
      }
    },

    loadCountys: function(value){
      const self = this;
      this.selectCounty='';
      this.countys =[];
      this.countys.push({id: '', name: '--请选择--'});
      if(null != value && '' != value){
        this.$axios.get('/api/dmz/district/childrens', {params: {parentCode: value, level: 'COUNTY'}}).then(function (res) {
          if (res.msg.flag == 0) {
            if(null != res.biz && !res.biz.empty){
              res.biz.forEach(function (item, index) {
                self.countys.push({id: item.id, name: item.name});
              });
            }
          }
        }, function (res) {
        });
      }
    },

    handlePicPreview:function(file, type) {
      if (!file.url && !file.preview) {
        file.preview = this.getBase64(file.originFileObj);
      }
      if(type=='LIF'){
        this.pics.lif = file.url || file.preview;
      }
      if(type=='LIB'){
        this.pics.lib = file.url || file.preview;
      }
      if(type=='LIC'){
        this.pics.lic = file.url || file.preview;
      }
      if(type=='PC'){
        this.pics.pc = file.url || file.preview;
      }
      if(type=='GSP'){
        this.pics.gsp = file.url || file.preview;
      }
    },
    beforePicUpload:function(file){
      const self = this;
      const isLt = file.size / 1024 / 1024 < 1;
      if(!isLt){
        self.$message.error({content: '图片文件大小需少于1M.', duration: 2});
        return false;
      }
      return true;
    },
    handleImgUpload:function(src, type){
      const self = this;
      const isLt = src.file.size / 1024 / 1024 < 1;
      if(!isLt){
        self.$message.error({content: '图片文件大小少于1M.', duration: 2});
        return false;
      }
      let params = new FormData();
      params.append("file", src.file);
      this.loadTip='正在上传资质文件图片....';
      this.loading = true;
      this.$axios.post('/api/dmz/ORGAN/file/upload', params, {headers: {
          'Content-Type': 'multipart/form-data'
        },timeout: 1000 * 60 * 15}).then(function(res){
        self.loading = false;
        if(res.msg.flag == 0){
          if(type=='LIF'){
            self.record.lif = res.biz.url;
            self.pics.lif = res.biz.path;
          }
          if(type=='LIB'){
            self.record.lib = res.biz.url;
            self.pics.lib = res.biz.path;
          }
          if(type=='LIC'){
            self.record.lic = res.biz.url;
            self.pics.lic = res.biz.path;
          }
          if(type=='PC'){
            self.record.pc = res.biz.url;
            self.pics.pc = res.biz.path;
          }
          if(type=='GSP'){
            self.record.gsp = res.biz.url;
            self.pics.gsp = res.biz.path;
          }
          self.discern(type, res.biz.path);
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(){
        self.loading = false;
      });

      return false;
    },

    foreverChange:function(e){
      console.info(e.target.checked);
      this.forever = e.target.checked == 1;
      if(this.forever){

      }
    },

    testDiscern:function(){
      let self = this;
	    //self.record.leaderName = res.biz.name;
	    //self.record.leaderIdcard = res.biz.idCard;

	    this.discern('LIC','static/1/organ/515707d12d6144a49212e5434ace4d07.jpg');
      //https://www.miaoxin.site/oss-server/oss-allpos-gpws/static/1/organ/515707d12d6144a49212e5434ace4d07.jpg
	    //https://www.miaoxin.site/oss-server/oss-allpos-gpws/
      //let params = {idCard:'4105821198405023510', name:'李勇', sex:'MALE', nation:'汉', birth:'1984/5/2', address:'长沙开福区湘江世纪城', validDate:'2033/9/24'}
      //this.record.leader.name = params.name;
      //this.record.leader.idcard = params.idCard;

    },

    /**
     * 智能识别
     */
    discern:function(type, path){
      if(type=='LIF'){//身份证正面
        this.idcardFrontDiscern(path);
      }else if(type=='LIB'){//身份证反面
        this.idcardBackDiscern(path);
      }else if(type=='LIC'){//营业执照
        this.businessLDiscern(path)
      }else if(type=='PC'){//执业许可证

      }else if(type=='GSP'){//药品经营许可证

      }
    },
    idcardFrontDiscern:function(path){
      let self = this;
      this.$axios.post('/api/dmz/idcard/discern/front',{path:path}).then(function(res){
        if(res.msg.flag == 0){
	        self.form.setFieldsValue({
		        leaderName : res.biz.name,
		        leaderIdcard : res.biz.idCard
	        })

        }
      },function (err) {

      })
    },

    idcardBackDiscern:function(path){
      let self = this;
      this.$axios.post('/api/dmz/idcard/discern/back',{path:path}).then(function(res){
        if(res.msg.flag == 0){
	        self.form.setFieldsValue({
            leaderStartDate : res.biz.startDate,
            leaderEndDate : res.biz.endDate
	        })
        }
      },function (err) {

      })
    },

    businessLDiscern:function(path){
      let self = this;
      this.$axios.post('/api/dmz/business/license/discern',{path:path}).then(function(res){
        if(res.msg.flag == 0){
          let _validDate = '';

	        self.form.setFieldsValue({
		        name : res.biz.name,
		        organCode : res.biz.registerNo,
		        address : res.biz.address,
		        organValidDate : res.biz.vaildDate||'',
            forever : res.biz.forever
	        })

        }
      },function (err) {

      })
    },

    getBase64:function(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    handleOrganImgUpload:function(src){
      const self = this;
      const isLt = src.file.size / 1024 / 1024 < 1;
      if(!isLt){
        self.$message.error({content: '图片文件大小少于1M.', duration: 2});
        return false;
      }
      let params = new FormData();
      params.append("file", src.file);
      this.loadTip='正在上传机构封面图片....';
      this.loading = true;
      this.$axios.post('/api/dmz/ORGAN/file/upload', params, {headers: {
          'Content-Type': 'multipart/form-data'
        },timeout: 1000 * 60 * 15}).then(function(res){
        self.loading = false;
        if(res.msg.flag == 0){
          self.record.pic = res.biz;
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(){
        self.loading = false;
      });

      return false;
    },

    handleOrganPicPreview:function(file) {
      if (!file.url && !file.preview) {
        file.preview = this.getBase64(file.originFileObj);
      }
    },

    previewImg (imgUrl) {
      this.$hevueImgPreview({
        url: imgUrl,
        keyboard: true,
      });
    },
    goBack:function (){
      this.$router.push({ path: '/layout/system/organ'});
    }
  }
}
</script>

<style>
  .custom-line{
    margin:15px 0px;
    border-top:1px solid #E5E5E5;

  }
  .pic-desc{
    margin-top: 12px;
    margin-bottom: 12px;
    text-align: center;
    color: #328AC7;
  }
.gpws-pic .ant-upload.ant-upload-select-picture-card{
  width: 125px!important;
  height: 125px!important;
}
.gpws-pic .ant-upload.ant-upload-select-picture-card > .ant-upload{
  padding: 0px!important;
}

.gpws-descriptions {
  margin-left: 48px;
  margin-right: 48px;
  margin-top: 24px;
}
.gpws-descriptions .ant-descriptions-item-label {
  text-align: center!important;
}
@media screen and (min-width: 1200px) {
  .gpws-descriptions .ant-descriptions-item-label {
    width: 198px!important;
  }
}
</style>
